import { Button, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import { AddIcon, SaveIcon } from "src/components/icons/ActionIcons";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import { GridContext } from "src/context/GridContext/GridContext";
import { GridKeikka_NewKeikkaContext } from "src/context/GridKeikka_NewKeikkaContext";
import { useUserData } from "src/context/userContext";
import propTypes from "prop-types";

const styles = {
  button2: {
    height: "70px",
    maxWidth: "600px",
    opacity: 0.8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  main: {
    width: "100%",
    padding: 10,
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  sourceAsiakasNimi: {
    fontSize: "1.3em",
    fontWeight: 600,
  },
  sourceAsiakasComment: { fontSize: "1.0em", fontWeight: 400 },
};

export default function GridKeikka_NewKeikka_NewKeikkaButton({ onSelect = () => {} }) {
  const theme = useTheme();
  const {
    sourceAsiakas,
    sourceAsiakasList,
    setSourceAsiakas,
    sourceAsiakasSettings,
    accordionExpanded,
    betoniAsiakas,
    pumppuAsiakas,
    sourceAsiakasListLoaded,
  } = useContext(GridKeikka_NewKeikkaContext);
  const { time, gridKeikkaEditorIsOpen, gridKeikka } = useContext(GridContext) || {};
  const { userAsiakas } = useUserData();

  const icon = gridKeikkaEditorIsOpen ? "save" : "add";
  let buttonText = null;
  let fontSize = "1.1em";

  if (buttonText === null) {
    if (!gridKeikkaEditorIsOpen) buttonText = `LUO UUSI ${sourceAsiakas?.sourceAsiakasNimi} TILAUS`;
    else buttonText = "TALLENNA";
  }

  const handleButtonClick = async (sourceAsiakas) => {
    setSourceAsiakas(sourceAsiakas);
    const _settings = sourceAsiakasSettings.find(
      (item) => item.linkedAsiakasId === sourceAsiakas.sourceAsiakasId
    );
    const settings = JSON.parse(_settings.asiakasAsiakasLinkJSON);

    let betoniAsiakasId = settings.setBetoniAsiakas
      ? _settings.linkedAsiakasId
      : betoniAsiakas?.betoniAsiakasId;
    if (settings.defaultBetoniAsiakasId > 0) betoniAsiakasId = settings.defaultBetoniAsiakasId;
    let pumppuAsiakasId = settings.setPumppuAsiakas
      ? _settings.linkedAsiakasId
      : pumppuAsiakas?.pumppuAsiakasId;
    if (settings.defaultPumppuAsiakasId > 0) pumppuAsiakasId = settings.defaultPumppuAsiakasId;
    const isBetoniSuoraLaskutus = settings.isBetoniSuoraLaskutus;
    const isPumppuSuoraLaskutus = settings.isPumppuSuoraLaskutus;
    const pumppuAika = new Date(time?.starttime || new Date()).setHours(7, 0, 0, 0);
    const pumppuKesto = 90;
    const vehicleId = userAsiakas?.defaultVehicleId || 0;
    const ownerAsiakasId = gridKeikka?.ownerAsiakasId || userAsiakas.asiakasId;
    onSelect({
      sourceAsiakasId: sourceAsiakas.sourceAsiakasId,
      betoniAsiakasId: betoniAsiakasId,
      pumppuAsiakasId: pumppuAsiakasId,
      ownerAsiakasId: ownerAsiakasId,
      pumppuAika: gridKeikka?.pumppuAika || pumppuAika,
      pumppuKesto: gridKeikka?.pumppuKesto || pumppuKesto,
      vehicleId: gridKeikka?.vehicleId || vehicleId,
      isPalkki: false,
      isKeikka: true,
      isBetoniSuoraLaskutus: isBetoniSuoraLaskutus === true,
      isPumppuSuoraLaskutus: isPumppuSuoraLaskutus === true,
    });
    return;
  };

  return (
    <div style={styles.main}>
      {!sourceAsiakasListLoaded && <ProgressBar show={!sourceAsiakasListLoaded} />}
      {!accordionExpanded ? (
        sourceAsiakasList.map((asiakas) => (
          <Button
            key={asiakas.sourceAsiakasId}
            variant="contained"
            color="primary"
            sx={{
              minWidth: "185px",
              height: "95px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: asiakas.sourceAsiakasColorCode,
              color: asiakas.sourceAsiakasColorCode
                ? theme.palette.getContrastText(asiakas.sourceAsiakasColorCode)
                : "initial",
            }}
            onClick={() => handleButtonClick(asiakas)}>
            <div>
              {gridKeikkaEditorIsOpen ? "TALLENNA" : "LUO UUSI tilaus"}
              <Typography sx={styles.sourceAsiakasNimi}>
                {asiakas?.sourceAsiakasNimi?.toUpperCase()}
              </Typography>
              <Typography sx={styles.sourceAsiakasComment}>
                {
                  // comment from sourceAsiakasSettings
                  sourceAsiakasSettings.find(
                    (item) => item.linkedAsiakasId === asiakas.sourceAsiakasId
                  )?.comment
                }
              </Typography>
            </div>
          </Button>
        ))
      ) : (
        <Button
          variant="contained"
          fullWidth
          sx={{
            minWidth: "185px",
            height: "95px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "90%",
            backgroundColor: sourceAsiakas ? sourceAsiakas.sourceAsiakasColorCode : "initial",
            color: sourceAsiakas?.sourceAsiakasColorCode
              ? theme.palette.getContrastText(sourceAsiakas.sourceAsiakasColorCode)
              : "initial",
          }}
          disabled={!sourceAsiakas}>
          <div style={{ width: "100%" }}>
            <div className="center" style={{ fontSize: fontSize, fontWeight: 600 }}>
              <ButtonIcon /> {buttonText}
            </div>
            <div className="center" style={{ gap: 10 }}>
              <div>Betoni:{betoniAsiakas?.betoniAsiakasNimi}</div>
              <div>Pumppu:{pumppuAsiakas?.pumppuAsiakasNimi}</div>
            </div>
          </div>
        </Button>
      )}
    </div>
  );

  function ButtonIcon() {
    if (icon === "add") return <AddIcon />;
    if (icon === "save") return <SaveIcon />;
    return null;
  }
}

GridKeikka_NewKeikka_NewKeikkaButton.propTypes = {
  onSelect: propTypes.func,
};
